export enum Methodology {
  FCFIXED_ALLOCATION = 'FCFIXED_ALLOCATION',
  SHADOW_PNL_SLICED = 'SLICED_SHADOWPNL',
}
